import store from "@/store";
import router from "../router/router";

function isModerToUser()
{
  console.log(localStorage.getItem("moderToUser"))
  return !!localStorage.getItem("moderToUser");
}
function isLoggedIn()
{
  return localStorage.getItem("auth");
}

function getName()
{
  return localStorage.getItem("name") || store.getters.name;
}

function getRole()
{
  return store.getters.role;
}

function getRoles()
{
  return store.getters.roles;
}

// function getAllDomains() {
//   return new Promise((resolve, reject) => {
//     store.dispatch("show")
//       .then((response) => {
//         return response.data.data
//       })
//       .then((domains) => {
//         resolve(domains);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   })
// }

// function getDomainById(id) {
//   return store.state.domain.domains.some(el => el.id == id);
// }

function getPermissions()
{
  return store.getters.permissions;
}

function checkAccessPermissions(to)
{
  return to.meta.requiresPermissions.some(el => getPermissions().includes(el) || getPermissions().includes("menu.admin.panel"));
}

/**
 * Check domain existence
 */
// router.beforeResolve((to, from, next) => {
//   if (to.params.hasOwnProperty("id")) {
//     getAllDomains()
//       .then((domains) => {
//         console.log(domains, domains.some((el) => el.id == to.params.id));

//         if (domains.some((el) => el.id == to.params.id)) {
//           next();
//         } else {
//           console.log("not found");

//           next({
//             name: "Page Not Found",
//             params: { '0': to.path }
//           });
//         }
//       })
//   }
// });

router.beforeEach((to, from, next) =>
{
  if (to.matched.some((record) => record.meta.authOnly)) {
    if (!isLoggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else if (isLoggedIn() && (to.name === "Login" || to.name === "Register")) {
      // if (getPermissions().includes("menu.clients.management")) {
      //   next({
      //     path: "/moderation-dashboard"
      //   })
      // } else {
      next({
        path: "/dashboard"
      });
      //}
    } else if (isLoggedIn()) {
      if (!getName()) {
        // Here is the problem
        // Temp solution: there is no need to return 500 - 97
        store.dispatch("auth")
          .then(() =>
          {
            next();
          })
          .catch((error) =>
          {
            //console.log("🚀 ~ router.beforeEach ~ error.response.status:", error, error.response.status)
            if (error.response.status == 401 || error.response.status == 419 || error.response.status == 500) {
              store.dispatch("logout")
                .then(() =>
                {
                  localStorage.removeItem("auth");
                });

              if (to.name !== "Login") {
                next({
                  path: "/login",
                  query: { redirect: to.fullPath },
                });
              } else {
                next(false);
              }
            } else {
              next({
                path: "/login",
                query: { redirect: to.fullPath },
              });
            }
          });
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guestOnly)) {
    if (isLoggedIn() && to.name !== "Login") {
      next();
    } else if (isLoggedIn() && (to.name === "Login" || to.name === "Register")) {
      next({
        path: "/dashboard"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.beforeResolve(async (to, from, next) =>
{
  // Request to obtain user's data
  if (isLoggedIn() && (!getRole() || !getPermissions().length)) {
    // await store.dispatch("auth")
    //   .then(() => {
    //     next();
    //   })
    //   .catch((error) => {
    //     if (error.response.status == 401 || error.response.status == 419) {
    //       store.dispatch("logout").then(() => {
    //         localStorage.removeItem("auth");
    //       })

    //       if (to.name !== "Login") {
    //         next({
    //           path: "/login",
    //           query: { redirect: to.fullPath },
    //         })
    //       } else {
    //         next();
    //       }
    //     } else {
    //       // if (getPermissions().includes("menu.clients.management")) {
    //       //   next({
    //       //     path: "/moderation-dashboard"
    //       //   })
    //       // } else {
    //       next({
    //         path: "/dashboard"
    //       })
    //       //}
    //     }
    //   })
  } else {
    next();
  }

  /**
   * Check the role requirements
   */
  if (to.matched.some((record) => record.meta.requiresRole)) {
    let lastMatched = to.matched.findLast(el => el);
    let requiresRole = lastMatched.meta.requiresRole || lastMatched.parent.meta.requiresRole || [];

    if (getRole() && requiresRole.length && requiresRole.some(el => el === getRole())) {
      next();
    } else {
      next({
        path: "/dashboard"
      });
    }
  } else {
    next();
  }

  /**
   * Check the permission requirements
   */
  if (to.matched.some((record) => record.meta.requiresPermissions)) {
    //console.log(getPermissions(), "permissions", checkAccessPermissions(to));

    if (getPermissions().length && to.meta.requiresPermissions !== undefined && checkAccessPermissions(to)) {
      next();
    } else {
      if (to.path === "/dashboard" && (getPermissions().includes("menu.clients.management") && getRoles().includes("moder"))) {
        next({
          path: "/moderation-dashboard"
        });
      } else if (to.path === "/moderation-dashboard" && !isModerToUser()) {
        next({
          path: "/moderation-dashboard"
        });
      } else {
        next({
          path: "/dashboard"
        });
      }
    }
  } else {
    next();
  }
});

export default router;
